import React from 'react'
import { Link } from 'react-router-dom'
import { Box, Stack, Title } from '@mantine/core'
import { AppButton, AppText } from '../../app/common/ui'

export default function NotFound () {
  return (
    <Box py="xl" sx={{ textAlign: 'center' }}>
      <Stack align="center" spacing="md">
        <Title order={2}>Page not found</Title>
        <AppText color="dimmed">
          We&apos;ve looked everywhere and could not find this page.
        </AppText>
        <AppButton component={Link} to="/blog">
          Return to Blog
        </AppButton>
      </Stack>
    </Box>
  )
}
